import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import {
  RadioInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import RadioButtonGroup from "../../components/common/ui/Inputs/RadioInput";
import { keywordAction, masterActions, authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import keywordSchema from "../../validation/keywordSchema";
import { MenuItem } from "../../_helpers/enumerator";
import { StoredProcedures } from "../../_helpers/enumerator";
import CustomLoader from "../../components/common/ui/Loader";

function AddOrEditKeyword() {
  const { ActionAdd, FilterTypeAdd, Status } = useSelector(
    (x) => x.dropdownOptions
  );

  const { facilityDropDown: facilitydata } = useSelector(
    (state) => state.master
  );

  const { loading, keywordData, insertUpdateResponse, keywordDetails } =
    useSelector((x) => x.keyword);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const dispatch = useDispatch();

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("KeywordList");
    }
  }, [commonFacilityCode]);

  let keywordNewData = { ...keywordData };

  const [errorMessage, setErrorMessage] = useState({});

  const [resetRadio, setresetRadio] = useState(false);

  useEffect(() => {
    if (resetRadio) {
      // NewData.ActiveStatus = NewData?.ActiveStatus; // Ensure base 10 for conversion
      // dispatch(keywordAction.setKeywordData(NewData));
      dispatch(
        keywordAction.setKeywordData({
          ...keywordData,
          ActiveStatus: keywordDetails?.ActiveStatus,
        })
      );
      setresetRadio(false);
    }
  }, [resetRadio]);

  const location = useLocation();

  const { id: MessageKeywordID } = location.state || {};

  // Load facility dropdown on component mount
  useEffect(() => {
    const loadFacilities = () => {
      dispatch(
        masterActions.LoadFacilityDropDown({
          facilityID: 0,
        })
      ).catch((error) => {
        console.error("Error loading facilities:", error);
        // Optionally handle the error here (e.g., show a notification)
      });
    };

    loadFacilities();
  }, [dispatch]);

  useEffect(() => {
    if (MessageKeywordID) {
      dispatch(keywordAction.GetKeywordDetails(MessageKeywordID))
        .then((res) => {
          // Check if the response has payload data
          if (res?.payload) {
            // Create a copy of the payload object
            let keywordNewData = { ...res?.payload };

            keywordNewData.CreatedBy = user.ManagementUserID;

            keywordNewData.WebUserSentActionID = ActionAdd?.find(
              (opts) => opts.label === res?.payload?.WebUserSentAction
            )?.value;

            keywordNewData.InmateSentActionID = ActionAdd?.find(
              (opts) => opts.label === res?.payload?.InmateSentAction
            )?.value;

            keywordNewData.KeyWordFilterTypeID = FilterTypeAdd?.find(
              (opts) => opts.label === res?.payload?.KeyWordFilterType
            )?.value;

            // Convert ActiveStatus to an integer
            keywordNewData.ActiveStatus = parseInt(
              res.payload.ActiveStatus,
              10
            ); // Ensure base 10 for conversion

            // Dispatch the updated param to the Redux store
            dispatch(keywordAction.setKeywordData(keywordNewData));
          }
        })
        .catch((err) => {
          // Log any errors that occur during the fetch
          console.warn("Error fetching keyword details:", err);
        });
    }
  }, [MessageKeywordID, dispatch]); // Ensure to include `dispatch` in the dependency array

  const handleBack = () => {
    dispatch(keywordAction.resetkeyword());
    history.navigate("/Admin/KeywordList");
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setErrorMessage((prev) => ({
      ...prev,
      [name]: "", // Clear the error message for documentName field
    }));

    const element = document.querySelector(`[name="${name}"]`);
    if (element && element.classList.contains("input-error")) {
      element.classList.remove("input-error");
    }

    keywordNewData[name] = value;
    dispatch(keywordAction.setKeywordData(keywordNewData));
  };

  const handleSelectChange = (Selectedoption, name) => {
    switch (name) {
      case "WebUserSentActionID":
        keywordNewData.WebUserSentAction = Selectedoption
          ? Selectedoption.label
          : "";
        keywordNewData.WebUserSentActionID = Selectedoption
          ? Selectedoption.value
          : 3;
        break;
      case "InmateSentActionID":
        keywordNewData.InmateSentAction = Selectedoption
          ? Selectedoption.label
          : "";
        keywordNewData.InmateSentActionID = Selectedoption
          ? Selectedoption.value
          : 3;
        break;
      case "KeyWordFilterTypeID":
        keywordNewData.KeyWordFilterType = Selectedoption
          ? Selectedoption.label
          : "";
        keywordNewData.KeyWordFilterTypeID = Selectedoption
          ? Selectedoption.value
          : 2;
        break;
      case "ActiveStatus":
        keywordNewData.ActiveStatus = parseInt(Selectedoption);
        break;
      default:
        break;
    }
    setErrorMessage((prev) => ({
      ...prev,
      [name]: "", // Clear the error message for documentName field
    }));
    dispatch(keywordAction.setKeywordData(keywordNewData));
  };

  const handleOnBlur = (e) => {
    let { name, value } = e.target;
    // if (submitted) {
    // Perform validation using the schema
    const { error } = keywordSchema(keywordNewData);

    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
    // }
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);

    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    const { error } = keywordSchema(keywordNewData);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(
          `input[name="${path}"], SelectInput[name="${path}"]`
        );
        if (inputElement) {
          // Add the input-error class if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.KeywordsMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableModifyOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Modify" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        const shouldEnableAddOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableModifyOptions && MessageKeywordID) {
          showToastNotification(
            "Update keyword has been disabled by the admin.",
            "error"
          );
          return;
        }
        if (!shouldEnableAddOptions && !MessageKeywordID) {
          showToastNotification(
            "Add keyword has been disabled by the admin.",
            "error"
          );
          return;
        }
        if (keywordNewData.MessageKeyWordID) {
          keywordNewData.Action = 2;
        }
        dispatch(keywordAction.GetKeywordInsertUpdate(keywordNewData))
          .then((res) => {
            switch (res.payload.IsSucceed) {
              case 1:
                // Insert Management User Activity Log
                dispatch(
                  authActions?.ManagementUserActivityLog({
                    ManagementUserID: user?.ManagementUserID,
                    facilityID: commonFacilityCode,
                    ProcedureName: StoredProcedures?.MessageKeyWordCPU,
                    UserAction: `Added a New Keyword  ( Keyword - ${keywordNewData?.MessageKeyWord} )`,
                  })
                );
                showToastNotification(
                  "Keyword information has been saved successfully.",
                  "success"
                );
                //dispatch(keywordAction.clearSearchKeyword());
                dispatch(keywordAction.resetkeyword());
                history.navigate("/Admin/KeywordList");
                break;
              case 2:
                // Insert Management User Activity Log
                dispatch(
                  authActions?.ManagementUserActivityLog({
                    ManagementUserID: user?.ManagementUserID,
                    facilityID: commonFacilityCode,
                    ProcedureName: StoredProcedures?.MessageKeyWordCPU,
                    UserAction: `Update Keyword ( MessageKeywordID - ${keywordNewData?.MessageKeyWordID} )`,
                  })
                );
                showToastNotification(
                  "Keyword information updated successfully.",
                  "success"
                );
                dispatch(keywordAction.resetkeyword());
                //dispatch(keywordAction.clearSearchKeyword());
                history.navigate("/Admin/KeywordList");
                break;
              case -1:
                showToastNotification("Insert Failed.", "error");
                break;
              case -2:
                showToastNotification("Keyword already exists.", "error");
                break;
            }
          })
          .catch((error) => {
            showToastNotification(
              "An error occurred. Please try again.",
              "error"
            );
          });
      })
      .catch((e) => { });
  };

  const handleReset = () => {
    setSubmitted(false);

    setErrorMessage({});

    if (MessageKeywordID) {
      let NewData = { ...keywordDetails };

      NewData.CreatedBy = user.ManagementUserID;

      NewData.WebUserSentActionID = ActionAdd?.find(
        (opts) => opts.label === NewData?.WebUserSentAction
      )?.value;

      NewData.InmateSentActionID = ActionAdd?.find(
        (opts) => opts.label === NewData?.InmateSentAction
      )?.value;

      NewData.KeyWordFilterTypeID = FilterTypeAdd?.find(
        (opts) => opts.label === NewData?.KeyWordFilterType
      )?.value;

      // Convert ActiveStatus to an integer
      NewData.ActiveStatus = NewData?.ActiveStatus; // Ensure base 10 for conversion
      dispatch(keywordAction.setKeywordData(NewData));

      setresetRadio(true);
      // dispatch(keywordAction.setKeywordData(keywordDetails));
    } else {
      dispatch(keywordAction.resetkeyword());
    }
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <div>
      <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h3 className=" text-color form_title_uppercase mb-0">
            {MessageKeywordID ? "Edit" : "Add"} Keyword
          </h3>
          <Button
            variant="primary"
            className="me-2"
            label={"Back"}
            type={"button"}
            status={"primary"}
            icon={"fa-solid fa-angle-left"}
            onClick={handleBack}
            disabled={false}
          />
        </div>

        <div className="mt-3">
          <h4 className="inner-header-bg text-color">
            {" "}
            <i className="fa-solid fa-circle-info me-2"></i>Keyword Information{" "}
          </h4>

          <form>
            <div className="row col-lg-12 mb-3">
              <div className="mb-1 col-sm-6 col-lg-4">
                <TextInput
                  name="MessageKeyWord"
                  label="Keyword"
                  value={keywordNewData?.MessageKeyWord}
                  handleChange={(e) => handleChange(e)}
                  placeholder="Enter Keyword"
                  maxLength={50}
                  errorMessage={errorMessage}
                  required
                  handleBlur={handleOnBlur}
                />
              </div>
              <div className="mb-1 col-sm-6 col-lg-4">
                <SelectInput
                  name="WebUserSentActionID"
                  label=" Web User Action"
                  options={ActionAdd}
                  value={keywordNewData?.WebUserSentActionID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "WebUserSentActionID")
                  }
                  isMulti={false}
                  isClearable={keywordNewData?.WebUserSentActionID !== 3}
                  errorMessage={errorMessage}
                  required
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "WebUserSentActionID" } })
                  }
                />
              </div>

              <div className="mb-1 col-sm-6 col-lg-4">
                <SelectInput
                  name="InmateSentActionID"
                  label="Inmate Action"
                  options={ActionAdd}
                  value={keywordNewData?.InmateSentActionID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "InmateSentActionID")
                  }
                  isMulti={false}
                  isClearable={keywordNewData?.InmateSentActionID !== 3}
                  errorMessage={errorMessage}
                  required
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "InmateSentActionID" } })
                  }
                />
              </div>

              <div className="mb-1 col-sm-6 col-lg-4">
                <SelectInput
                  name="KeyWordFilterTypeID"
                  label="Filter Type"
                  options={FilterTypeAdd}
                  value={keywordNewData?.KeyWordFilterTypeID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "KeyWordFilterTypeID")
                  }
                  isMulti={false}
                  isClearable={keywordNewData?.KeyWordFilterTypeID !== 2}
                  errorMessage={errorMessage}
                  required
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "KeyWordFilterTypeID" } })
                  }
                />
              </div>
              <div className="mt-3 col-lg-4">
                <RadioButtonGroup
                  name="ActiveStatus"
                  id="ActiveStatus"
                  label="Status"
                  selectedValue={keywordNewData?.ActiveStatus} // Default to "2" if Status is not set
                  handleChange={(e) =>
                    handleSelectChange(e.target.value, "ActiveStatus")
                  }
                  options={Status}
                  // required={true} // Set to true if the field is required
                  disabled={false} // Set to true if you want to disable the radio buttons
                />
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-3 gap-3">
              <Button
                className="me-2"
                label={MessageKeywordID ? "Update" : "Save"}
                type="submit"
                variant="danger"
                icon={
                  MessageKeywordID
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-floppy-disk"
                }
                status={"success"}
                onClick={(e) => handleSubmit(e)}
                disabled={false}
              />
              <Button
                className="me-2"
                label="Reset"
                type="reset"
                variant="danger"
                icon={"fa-solid fa-rotate-right"}
                status={"secondary"}
                onClick={handleReset}
                disabled={false}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default React.memo(AddOrEditKeyword);
